import { TOTAL_PAGES } from '@/lib/book';

export type ViewMode = 'single' | 'spread';

/** 현재 페이지가 속한 펼침 묶음(1쪽·148쪽은 단독) */
export function spreadPages(page: number, mode: ViewMode, total = TOTAL_PAGES): number[] {
  const p = Math.min(Math.max(page, 1), total);
  if (mode === 'single' || p === 1 || p === total) return [p];
  const left = p % 2 === 0 ? p : p - 1;
  return [left, Math.min(left + 1, total)];
}

export function groupFirst(page: number, mode: ViewMode, total = TOTAL_PAGES): number {
  const p = Math.min(Math.max(page, 1), total);
  if (mode === 'single' || p === 1 || p === total) return p;
  return p % 2 === 0 ? p : p - 1;
}

export function groupLast(page: number, mode: ViewMode, total = TOTAL_PAGES): number {
  const p = Math.min(Math.max(page, 1), total);
  if (mode === 'single' || p === 1 || p === total) return p;
  return p % 2 === 0 ? Math.min(p + 1, total) : p;
}

export function nextPage(page: number, mode: ViewMode, total = TOTAL_PAGES): number {
  if (mode === 'single') return Math.min(page + 1, total);
  return Math.min(groupLast(page, mode, total) + 1, total);
}

export function prevPage(page: number, mode: ViewMode, total = TOTAL_PAGES): number {
  if (mode === 'single') return Math.max(page - 1, 1);
  return Math.max(groupFirst(page, mode, total) - 1, 1);
}

export function clampPage(page: number, total = TOTAL_PAGES): number {
  return Math.min(Math.max(Math.round(page), 1), total);
}